import { AnalyticsUserEvent } from '@fruitful/types';
import { useLocalSearchParams } from 'expo-router';
import { isWeb } from 'smoothie';

import LoginOTP from '../../../auth/components/otp/LoginOTP';
import usePlaidOAuth from '../../../auth/hooks/usePlaidOAuth';
import { useViewEvents } from '../../../events/hooks/useViewEvents';
import { captureException, track } from '../../../logger/Logger';
import NoAccessScreen from '../../no-access';

export default function OTPPage() {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('OAuthIndexPage');

    const { mutateAsync: plaidOAuth } = usePlaidOAuth();
    const { auth_request_id } = useLocalSearchParams();

    if (!isWeb) {
        captureException(
            new Error('Cannot access FDX OAuth OTP screen in native app'),
        );
        return <NoAccessScreen />;
    }

    const plaidOAuthRedirect = async () => {
        if (auth_request_id == null) {
            throw new Error('auth_request_id missing from querystring');
        }
        const { redirectUri } = await plaidOAuth({
            body: {
                auth_request_id: auth_request_id as string,
            },
        });

        track(AnalyticsUserEvent.FDX_OAUTH_COMPLETE);

        window.location.href = redirectUri;
    };

    return (
        <LoginOTP
            onSuccess={plaidOAuthRedirect}
            includeRememberDevice={false}
        />
    );
}
